import styles from './BrandUnderline.module.css';

// Animated curved headline underline for the auth brand panels.
export const BrandUnderline = () => (
  <svg
    className={styles.underlineSvg}
    viewBox="0 0 300 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      className={styles.underlinePath}
      d="M4 12 C 60 3, 180 16, 296 9"
      strokeWidth="3.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);
